import React from 'react';
import { NgoBlockProps } from './index';
import useStyle from './OngBlock.style';
import { ReactComponent as RightArrow } from '../../../../assets/svg/rightarrow.svg';
import { classNames } from '../../../../helpers/style/classNames';
import { getNgoImage, getNgoTitleAndSubtitle } from '../../../../helpers/ong';

export const NgoBlockView = ({ onClick, ong }: NgoBlockProps) => {
  const classes = useStyle();
  const { title, subtitle } = getNgoTitleAndSubtitle(ong);
  return (
    <div onClick={onClick} className={classNames([classes.root, classes[ong]])}>
      <div className={classes.content}>
        <div>
          <p className={classes.title}>{title}</p>
          <p className={classes.subtitle}>{subtitle}</p>
        </div>
        {!ong && (
          <p className={classes.cta}>
            Je choisis mon ONG <RightArrow />
          </p>
        )}
        {ong && (
          <p className={classes.cta}>
            Voir ma contribution
            <RightArrow />
          </p>
        )}
      </div>
      <img src={getNgoImage(ong)} alt="ong" />
    </div>
  );
};
